import { Box, styled } from '@mui/material';
import ActionButtons, {
  type ActionButtonType,
} from 'further-ui/components/ActionButtons';
import { Row } from 'further-ui/components/Layout';
import { FC, PropsWithChildren } from 'react';
import FiltersGroup from './FiltersGroup';

export { default as Filter } from './Filter';
export { FiltersGroup };

type Props = {
  className?: string;
  justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between';
  actions?: Array<ActionButtonType>;
};

const ButtonsContainer = styled(Box)({
  display: 'flex',
  flexBasis: 'content',
  flexShrink: 0,
});

const PageFilters: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  justify = 'flex-start',
  actions,
}) => {
  return (
    <Row
      spacing="md"
      centered
      breakpoint="md"
      fullWidth
      className={className}
      justify="space-between"
    >
      <FiltersGroup className={className} justify={justify}>
        {children}
      </FiltersGroup>
      {!!actions?.length && (
        <ButtonsContainer>
          <ActionButtons actions={actions} />
        </ButtonsContainer>
      )}
    </Row>
  );
};

export default PageFilters;
